import React, { ChangeEvent, useState, SyntheticEvent } from 'react';

import { useDispatch } from 'react-redux';

import { t } from '../../../locales/i18n';

const ticketPrefixes = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
import { saveQueueSettingsSaga, QueueSettingsForm } from '../';
import { Queue } from '../../../types/queue';
import { InputWrapper } from '../../../components/forms/input-wrapper';
import { ActionPanel } from '../../../components/forms/action-panel';
import { Input, Dropdown, Button } from 'semantic-ui-react';
import styled from 'styled-components';

const Container = styled.section``;

export interface BaseSettingsProps {
  queue: Queue | null;
}

export function BaseSettings(props: BaseSettingsProps) {
  const { queue } = props;
  const dispatch = useDispatch();
  const saveQueueSettings = (queueSettings: QueueSettingsForm) =>
    dispatch(saveQueueSettingsSaga({ queueId: (queue && queue.id) || '', baseSettings: queueSettings }));
  const [isDirty, setDirty] = useState(false);
  const [name, setName] = useState((queue && queue.name) || '');
  const [ticketPrefix, setTicketPrefix] = useState((queue && queue.ticketPrefix) || '');
  return (
    <Container>
      <InputWrapper label={t('queueSettingsPage.queueName')}>
        <Input
          value={name}
          onChange={(event: ChangeEvent<HTMLInputElement>, { value }) => {
            setName(value);
            setDirty(true);
          }}
        />
      </InputWrapper>
      <InputWrapper
        helperText={t('queueSettingsPage.queuePrefix.helperText')}
        label={t('queueSettingsPage.queuePrefix')}
      >
        <Dropdown
          selection
          options={[...ticketPrefixes].map((prefix) => ({
            value: prefix,
            key: prefix,
            text: prefix
          }))}
          value={ticketPrefix}
          onChange={(event: SyntheticEvent<HTMLElement>, { value }) => {
            setTicketPrefix(value as string);
            setDirty(true);
          }}
        />
      </InputWrapper>
      <ActionPanel>
        <Button
          variant="raised"
          secondary
          disabled={!isDirty}
          onClick={() => {
            saveQueueSettings({
              name,
              ticketPrefix
            });
            setDirty(false);
          }}
        >
          {t('button.save')}
        </Button>
      </ActionPanel>
    </Container>
  );
}
